import { render, staticRenderFns } from "./v-contextual-content.vue?vue&type=template&id=675031ae&scoped=true"
import script from "./v-contextual-content.vue?vue&type=script&lang=js"
export * from "./v-contextual-content.vue?vue&type=script&lang=js"
import style0 from "./v-contextual-content.vue?vue&type=style&index=0&id=675031ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675031ae",
  null
  
)

export default component.exports